import React, { useState } from 'react';
import { Box, Typography, LinearProgress, Tooltip, CircularProgress, Button } from '@mui/material';
import ScannerIcon from '@mui/icons-material/Scanner';
import WarningIcon from '@mui/icons-material/Warning';
import AutoAwesomeMosaicIcon from '@mui/icons-material/AutoAwesomeMosaic';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PurchaseModal from '../Purchase/PurchaseModal';

const ScanQuota = ({ quotaInfo, isOpen, loading }) => {
    const [isPurchaseModalOpen, setIsPurchaseModalOpen] = useState(false);

    if (loading) {
        return (
            <Box sx={{ p: 2, display: 'flex', justifyContent: 'center' }}>
                <CircularProgress size={20} />
            </Box>
        );
    }

    if (!quotaInfo) return null;

    const { used, total, remaining } = quotaInfo;
    const percentage = Math.min((used / total) * 100, 100);
    const isLow = remaining <= 2;
    const isExhausted = remaining === 0;
    
    const handleOpenPurchaseModal = () => {
        setIsPurchaseModalOpen(true);
    };

    const handleClosePurchaseModal = () => {
        setIsPurchaseModalOpen(false);
    };
    
    if (!isOpen) {
        return (
            <Tooltip title={`${remaining}/${total} scans remaining`} placement="right">
                <Box sx={{ p: 2 }}>
                    <LinearProgress 
                        variant="determinate" 
                        value={percentage}
                        sx={{ height: 4, borderRadius: 2 }}
                    />
                </Box>
            </Tooltip>
        );
    }

    return (
        <Box sx={{ p: 2 }}>
            <Typography variant="caption" color="text.secondary" gutterBottom>
                Scan Credits
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
                    {remaining}/{total}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                    remaining
                </Typography>
            </Box>
            <LinearProgress 
                variant="determinate" 
                value={percentage}
                sx={{ height: 4, borderRadius: 2 }}
            />
        </Box>
    );
};

export default ScanQuota;
